export function generateUUID() {
  // primary method uses native browser API
  if (crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // fallback method used if running on insecure HTTP pages
  // uses crypto.getRandomValues to ensure the ID is still securely random.
  return (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}